import React, { FC, useEffect, useMemo, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { MyAccountContainer } from '@components/organisms/MyAccountContainer/MyAccountContainer';
import { Container } from '@components/atoms/Container';
import { Space } from '@components/atoms/Space';
import { useSettings } from '@hooks/useSettings';
import { useHtmlTransformer } from '@hooks/useHtmlTransformer';
import { SITE_URLS } from '@constants';

export const MyAccountLegal: FC = () => {
    const { pageKey } = useParams();
    const { t } = useTranslation();
    const { getPage } = useSettings();
    const { transformHtml } = useHtmlTransformer();
    const location = useLocation();
    const navigate = useNavigate();

    const currentKey = useMemo(() => pageKey || 'privacy-policy', [pageKey]);

    const translations = {
        sectionTitle: t('my-account-sidebar.title-legal-information'),
        pageTitle: t(`policy-component.${currentKey}.title`),
    };

    const [pageContent, setPageContent] = useState<string | null>(null);

    useEffect(() => {
        const content = getPage(currentKey);
        if (!content) {
            const fallback = getPage('terms-and-conditions') ? 'terms-and-conditions' : 'privacy-policy';
            if (currentKey !== fallback) {
                navigate(`/${SITE_URLS.myAccountLegalPage.replace(':pageKey', fallback)}`, { replace: true, state: { from: location.pathname } });
                return;
            }
        }
        setPageContent(content || null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentKey]);

    return (
        <MyAccountContainer title={translations.pageTitle}>
            <>
                <Space spaceBreakpoints={{ xs: { space: 30 }, md: { space: 30 } }} />
                <Container classes="px-0 px-md-3">
                    <div className="row">
                        <div className="col-12">{pageContent && transformHtml(pageContent)}</div>
                    </div>
                </Container>
                <Space spaceBreakpoints={{ xs: { space: 30 }, md: { space: 30 } }} />
            </>
        </MyAccountContainer>
    );
};

